import type { FC } from 'react';
import Button from '@/ui/components/Button/Button';
import Typography from '@/ui/components/Typography/Typography';

import $ from './RouteUnavailableFallback.module.scss';

type RouteUnavailableFallbackProps = {
  locale: string;
  onRetry?: () => void;
};

const RouteUnavailableFallback: FC<RouteUnavailableFallbackProps> = ({
  locale,
  onRetry,
}) => (
  <section className={$.container} aria-live="polite">
    <Typography variant="h2">This page is temporarily unavailable</Typography>
    <Typography variant="bodyMedium">
      We could not load page content right now. Please try again in a moment.
    </Typography>
    {onRetry ? (
      <Button onClick={onRetry}>Try again</Button>
    ) : (
      <Button href={`/${locale}`}>Try again</Button>
    )}
  </section>
);

export default RouteUnavailableFallback;
